import { errorMessages } from '~/constants/errorMessages.ts';
import { TExplanationAnswerComment, TPurposeOfBusinessRelations } from './types';
import * as Yup from 'yup';

export const getBusinessRelatonsInitialValuesSoleTrader = (
  formData: TPurposeOfBusinessRelations
) => ({
  businessDescription: formData?.businessDescription || '',
  typesOfActivity: formData?.typesOfActivity || null,
  isPremisesInConflictZone: formData?.isPremisesInConflictZone ?? null,
  cashManagement: !!formData?.cashManagement,
  loans: !!formData?.loans,
  deposits: !!formData?.deposits,
  tradeFinanceAndDocumentaryOperations: !!formData?.tradeFinanceAndDocumentaryOperations,
  securitiesOperations: !!formData?.securitiesOperations,
  paymentCards: !!formData?.paymentCards,
  other: formData?.other,
  explanation: formData?.explanation || [],
  type: formData?.type,
});

export const getBusinessRelatonsInitialValuesReIdentificationSoleTrader = (
  formData: TPurposeOfBusinessRelations
) => ({
  businessDescription: formData?.businessDescription || '',
  typesOfActivity: formData?.typesOfActivity || null,
  isPremisesInConflictZone: formData?.isPremisesInConflictZone ?? null,
  cashManagement: !!formData?.cashManagement,
  loans: !!formData?.loans,
  deposits: !!formData?.deposits,
  tradeFinanceAndDocumentaryOperations: !!formData?.tradeFinanceAndDocumentaryOperations,
  securitiesOperations: !!formData?.securitiesOperations,
  paymentCards: !!formData?.paymentCards,
  other: formData?.other ?? null,
  hasBusinessActivityChanges: formData?.hasBusinessActivityChanges ?? null,
  explanation: formData?.hasBusinessActivityChanges ? formData?.explanation || [] : [],
});

export const getBusinessRelatonsInitialValuesLegalResident = (
  formData: TPurposeOfBusinessRelations
) => ({
  businessDescription: formData?.businessDescription || '',
  typesOfActivity: formData?.typesOfActivity || null,
  registeredShareCapital: formData?.registeredShareCapital || '',
  paidShareCapital: formData?.paidShareCapital || '',
  isLicensed: formData?.isLicensed ?? null,
  licenses:
    (formData?.licenses?.length as number) > 0
      ? formData?.licenses?.map((lic) => ({
          licenseName: lic?.licenseName || '',
          licenseDate: lic?.licenseDate || null,
          licenseNumber: lic?.licenseNumber || '',
          licenseOrganisationCreate: lic?.licenseOrganisationCreate || '',
          licenseExpiryTerm: lic?.licenseExpiryTerm || null,
        }))
      : [],
  isNonProfitOrganization: formData?.isNonProfitOrganization ?? null,
  nonProfitDetails: formData?.nonProfitDetails || [],
  isNewOrNonProfitEntity: formData?.isNewOrNonProfitEntity ?? null,
  explanation: formData?.isNewOrNonProfitEntity ? formData?.explanation || [] : [],
  isPremisesInConflictZone: formData?.isPremisesInConflictZone ?? null,
  premisesTypesInConflictZone: formData?.premisesTypesInConflictZone ?? [],
  arePremisesUsedInWarZones: formData?.arePremisesUsedInWarZones ?? false,
  isIncomeReceivedFromWarZones: formData?.isIncomeReceivedFromWarZones ?? false,
  isEmployeesReceiveSalary: formData?.isEmployeesReceiveSalary ?? false,
  isReRegistrationAgreed: formData?.isReRegistrationAgreed ?? false,
  cashManagement: !!formData?.cashManagement,
  loans: !!formData?.loans,
  deposits: !!formData?.deposits,
  tradeFinanceAndDocumentaryOperations: !!formData?.tradeFinanceAndDocumentaryOperations,
  securitiesOperations: !!formData?.securitiesOperations,
  other: formData?.other || null,
  isTradingInfoOnCapitalMarketsProvided: formData?.isTradingInfoOnCapitalMarketsProvided ?? false,
  tradingInfoContacts: formData?.tradingInfoContacts || [],
  isDepositoryInfoOnCapitalMarketsProvided:
    formData?.isDepositoryInfoOnCapitalMarketsProvided ?? false,
  depositoryInfoContacts: formData?.depositoryInfoContacts || [],
  type: formData?.type,
});

export const getCommentContextInfo = (context: Yup.TestContext<Yup.AnyObject>) => {
  const pathParts = context.path.match(/\d+/g);
  const questionIndex = Number(pathParts?.[0]);
  const answerIndex = Number(pathParts?.[1]);

  const explanation = context.from?.[3]?.value?.explanation;
  const question = explanation?.[questionIndex];
  const answer = question?.answers?.[answerIndex];

  const questionId = Number(question?.questionId);
  const answerValue = Number(answer?.value);
  return { questionId, answerValue };
};

export function checkComment(
  this: Yup.TestContext,
  commentObj: TExplanationAnswerComment,
  field: string
) {
  const { questionId, answerValue } = getCommentContextInfo(this);
  if (questionId === 9 && answerValue !== 26) {
    if (!(commentObj as TExplanationAnswerComment)?.[field as keyof typeof commentObj]?.trim()) {
      return this.createError({
        path: `${this.path}.${field}`,
        message: errorMessages.FIELD_REQUIRED,
      });
    }
  }
  return true;
}

export function checkServices(this: Yup.TestContext, value: TPurposeOfBusinessRelations) {
  const services = [
    value?.cashManagement,
    value?.loans,
    value?.deposits,
    value?.tradeFinanceAndDocumentaryOperations,
    value?.securitiesOperations,
    value?.paymentCards,
    !!value?.other?.trim(),
  ].filter(Boolean);

  if (!services.length) {
    return this.createError({
      path: 'other',
      message: errorMessages.CHOOSE_SERVICE,
    });
  }
  return true;
}
